import CONSTANTS from '../../../constants';

export function planogram(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.PLANOGRAM.PLANOGRAM_GET) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}